import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/event/:id/registration",
    name: "Regis",
    component: () => import("@/views/Regis.vue"),
  },
  {
    path: "/event/:id/view",
    name: "EventViews",
    component: () => import("@/views/view.vue"),
  },
  {
    path: "/Admin",
    name: "Admin",
    component: () => import("@/views/Backend/Home.vue"),
  },
  {
    path: "/Admin/event/:id/view",
    name: "EventAdmin",
    component: () => import("@/views/Backend/Eventv1.vue"),
  },
  {
    path: "/Admin/event/old/:id/view",
    name: "oEventAdmin",
    component: () => import("@/views/Backend/Event.vue"),
  },
  {
    path: "/event/:id/checkin",
    name: "Checkin",
    component: () => import("@/views/checkin.vue"),
  },
  {
    path: "/event/:id/walkin",
    name: "walkin",
    component: () => import("@/views/Walkin.vue"),
  },
  {
    path: "/Page-Not-Found",
    name: "PageNotFound",
    component: () => import("@/views/404.vue"),
  },
  {
    path: "*",
    redirect: "Page-Not-Found",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
